import axios from 'axios'
import { host } from '../../helper/config'
import { getItemPerPage } from '../../helper/helper'

const PLUGINS_NAME = 'admin-work-time'

export const getAllWorkTime = async (token, page) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/get-all-v2`, {
        page: page,
        itemPerPage: getItemPerPage()
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return {}
}

export const getAllClassicWorkTime = async (token, page) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/get-all-classic`, {
        page: page,
        itemPerPage: getItemPerPage()
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return {}
}

export const enableAuto = async (token, id) => {
    const response = await axios.post(`${host}/admin-work-time/toggle-auto`, {
        id: id,
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data.rolledMethod
    }
    return true
}

export const disableAuto = async (token, id) => {
    const response = await axios.post(`${host}/admin-work-time/toggle-auto`, {
        id: id,
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return false
}
